<div class="sidebar" [ngClass]="{'collapsed': isCollapsed}" id="sidebar-main">
  <div class="sidebar-header" id="sidebar-header">
    <button class="collapse-btn" (click)="toggleCollapse()" id="sidebar-collapse-btn"
      [attr.aria-label]="translate(isCollapsed ? 'nav.expandSidebar' : 'nav.collapseSidebar')">
      <i class="fas" [ngClass]="isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'" id="sidebar-collapse-icon" aria-hidden="true"></i>
    </button>
  </div>

  <div class="sidebar-content" id="sidebar-content">
    <ul class="nav-menu" id="sidebar-nav-menu">
      <!-- Home - Visible para todos los usuarios -->
      <li class="nav-item" id="sidebar-home-item">
        <a routerLink="/home" routerLinkActive="active" id="sidebar-home-link">
          <i class="fas fa-home" id="sidebar-home-icon"></i>
          <span class="nav-text" id="sidebar-home-text">{{ translate('nav.home') }}</span>
        </a>
      </li>

      <!-- Chat - Visible para todos los usuarios -->
      <li class="nav-item" id="sidebar-chat-item">
        <a routerLink="/chat" routerLinkActive="active" id="sidebar-chat-link">
          <i class="fas fa-comments" id="sidebar-chat-icon"></i>
          <span class="nav-text" id="sidebar-chat-text">{{ translate('nav.chat') }}</span>
        </a>
      </li>

      <!-- Knowledge Hub - Una sola entrada que agrupa Generar / Conocimiento / Cambios / Alertas.
           Visible si cualquiera de las 4 features está activa; cada pestaña se gatea por su flag. -->
      <li class="nav-item" *ngIf="knowledgeHubMenuEnabled" id="sidebar-knowledge-hub-item">
        <a routerLink="/knowledge-hub" routerLinkActive="active" id="sidebar-knowledge-hub-link">
          <i class="fas fa-layer-group" id="sidebar-knowledge-hub-icon"></i>
          <span class="nav-text" id="sidebar-knowledge-hub-text">{{ translate('nav.knowledgeHub') }}</span>
        </a>
      </li>

      <!-- Documentos - Visible para todos los usuarios -->
      <li class="nav-item" id="sidebar-documents-item">
        <a routerLink="/documents" routerLinkActive="active" id="sidebar-documents-link">
          <i class="fas fa-file-alt" id="sidebar-documents-icon"></i>
          <span class="nav-text" id="sidebar-documents-text">{{ translate('nav.documents') }}</span>
        </a>
      </li>

      <!-- Plan - Destino unificado (plan/uso + detalle admin) -->
      <li class="nav-item" id="sidebar-usage-item">
        <a routerLink="/plan" routerLinkActive="active" id="sidebar-usage-link">
          <i class="fas fa-gauge-high" id="sidebar-usage-icon"></i>
          <span class="nav-text" id="sidebar-usage-text">{{ translate('nav.plan') }}</span>
        </a>
      </li>

      <!-- Tareas - Visible para todos los usuarios -->
      <li class="nav-item" id="sidebar-tasks-item">
        <a routerLink="/tasks" routerLinkActive="active" id="sidebar-tasks-link">
          <i class="fas fa-tasks" id="sidebar-tasks-icon"></i>
          <span class="nav-text" id="sidebar-tasks-text">{{ translate('nav.tasks') }}</span>
        </a>
      </li>

      <li class="nav-divider" id="sidebar-divider"></li>

      <!-- Admin - Solo visible para administradores -->
      <li class="nav-item" id="sidebar-admin-item">
        <a routerLink="/admin" routerLinkActive="active" id="sidebar-admin-link">
          <i class="fas fa-shield-alt" id="sidebar-admin-icon"></i>
          <span class="nav-text" id="sidebar-admin-text">{{ translate('nav.admin') }}</span>
        </a>
      </li>

      <!-- Perfil de usuario -->
      <li class="nav-item" id="sidebar-profile-item">
        <a routerLink="/profile" routerLinkActive="active" id="sidebar-profile-link">
          <i class="fas fa-user" id="sidebar-profile-icon"></i>
          <span class="nav-text" id="sidebar-profile-text">{{ translate('nav.profile') }}</span>
        </a>
      </li>

      <!-- Configuración -->
      <li class="nav-item" id="sidebar-settings-item">
        <a routerLink="/preferencias" routerLinkActive="active" id="sidebar-settings-link">
          <i class="fas fa-cog" id="sidebar-settings-icon"></i>
          <span class="nav-text" id="sidebar-settings-text">{{ translate('nav.settings') }}</span>
        </a>
      </li>

      <!-- Cerrar sesión -->
      <li class="nav-item logout" id="sidebar-logout-item">
        <a href="#" (click)="logout(); $event.preventDefault()" id="sidebar-logout-link">
          <i class="fas fa-sign-out-alt" id="sidebar-logout-icon"></i>
          <span class="nav-text" id="sidebar-logout-text">{{ translate('nav.logout') }}</span>
        </a>
      </li>

    </ul>
  </div>
</div>
